import { defineMessages } from "react-intl";

const messages = defineMessages({
    scaling: {
        id: "tasks.rhythmSorting.scaling",
    },
});

export default messages;
